import { selectorFamily } from 'recoil';

import ordersAtom from '~/recoil/atom/orders';
import cartTypeAtom from '~/recoil/atom/cartType';

import * as fp from 'lodash/fp';

import { CartItem, CartType } from '~/types/cart';
import enterpriseGroupBuyOrdersAtom from '../atom/enterpriseGroupBuy/enterpriseGroupBuyOrders';
import globalEnterpriseGroupBuyAtom from '../atom/enterpriseGroupBuy/globalEnterpriseGroupBuyAtom';

const cartItemCount = selectorFamily<number, { storeId: string; itemId: string }>({
  key: 'cartItemInventory',
  get:
    ({ storeId, itemId }) =>
    ({ get }) => {
      const cartType = get(cartTypeAtom);
      const { data = null } = get(globalEnterpriseGroupBuyAtom);
      const orders = get(!!data ? enterpriseGroupBuyOrdersAtom : ordersAtom);

      const storeOrder = orders.find((storeOrder) => fp.eq(storeId, storeOrder.storeId));

      if (!storeOrder) {
        return 0;
      }

      return fp.pipe(
        fp.filter<CartItem>(({ id }) => fp.eq(id, itemId)),
        fp.sumBy<CartItem>(({ count }) => count),
      )(
        cartType === CartType.CART_PERSONAL
          ? storeOrder.items
          : storeOrder.groupItems.flatMap(fp.prop('items')),
      );
    },
});

export default cartItemCount;
